<template>
  <!-- 推送数据管理 -->
  <div class="page">
    <loading v-if="showLoading" />
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="数据类型：" prop="dataType">
            <el-select size="small" v-model="searchData.dataType" clearable filterable>
              <el-option
                v-for="item in dataTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="batching(true)">
            批量处理
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>

      <div class="table_box">
        <el-table ref="table" :data="tableList" :height="tableHeight">
          <el-table-column prop="projectTypeCnd" label="项目类型" align="center"> </el-table-column>
          <el-table-column prop="dataBase" label="数据库" align="center"> </el-table-column>
          <el-table-column prop="dataType" label="数据类型" align="center"> </el-table-column>
          <el-table-column prop="processData" label="未处理数据" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i class="icona icon-edit" title="处理" @click="batching(false, scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLoading: false,
      // 查询条件
      searchData: {
        dataType: 2,
        projectType: "",
      },
      //数据类型
      dataTypeList: [
        {
          value: 2,
          name: "用户数据",
        },
        {
          value: 3,
          name: "课程数据",
        },
        {
          value: 4,
          name: "题库数据",
        },
        {
          value: 5,
          name: "资源数据",
        },
        {
          value: 6,
          name: "课程内容和活动实施信息",
        },
        {
          value: 7,
          name: "日志数据",
        },
        {
          value: 8,
          name: "试题数据",
        },
        {
          value: 9,
          name: "作业、测试和考试信息",
        },
        {
          value: 10,
          name: "作业、测试和考试引用试题关系表",
        },

        {
          value: 11,
          name: "论坛信息",
        },
        {
          value: 12,
          name: "开课",
        },
        {
          value: 13,
          name: "选课",
        },
        {
          value: 14,
          name: "课程公告",
        },
        {
          value: 15,
          name: "课程内容和活动部署信息",
        },
        {
          value: 16,
          name: "论坛帖子和回复信息",
        },
        {
          value: 17,
          name: "作业、测试和考试测评打分",
        },
        {
          value: 18,
          name: "课程学习成绩信息",
        },
      ],
      // 表格数据
      tableList: [],
      tableHeight: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.searchData.projectType = this.$store.state.statusRadio;
      this.renderTableHeight();
      window.onresize = () => this.renderTableHeight();
      this.search();
    });
  },
  methods: {
    // 动态渲染表格的高度
    renderTableHeight() {
      this.tableHeight = document.getElementsByClassName("table_box")[0].offsetHeight;
    },
    // 查询表格
    search() {
      this.showLoading = true;
      this.$axios
        .post(this.$apiurls.getDataInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.tableList = res.data;
          }
          this.showLoading = false;
        });
    },
    // 重置表格
    reset() {
      this.searchData.dataType = this.dataTypeList[0].value;
      this.search();
    },
    // 批量处理
    batching(flag, item) {
      this.showLoading = true;
      if (flag) this.searchData.db = "";
      else this.searchData.db = item.dataBase.replaceAll("data", "");
      this.$axios
        .post(this.$apiurls.processData, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.$message({
              message: "处理成功！",
              type: "success",
            });
            this.showLoading = true;
            setTimeout(() => {
              this.search();
            }, 1000);
          }
        });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.addition{
  margin-top: 5px;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}
.el-form {
  height: 100%;
}

// 分配专业
.distribute ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}
.distributionBox {
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.specialty_box {
  height: 470px;
  overflow-y: auto;
  // background: #a5a4bf;
  margin-bottom: 60px;
  margin-right: 20px;
}
.specialty_bottom {
  position: absolute;
  bottom: -45px;
  right: 38%;
}
.el-tree,
::v-deep.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content,
::v-deep.el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;
    .el-select-dropdown__item {
      color: #fff !important;
    }
    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }
    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }
    .selected {
      color: rgba(27, 246, 248);
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}
.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.el-icon-document {
  font-size: 18px;
  color: #1bf6f8;
  margin-right: 5px;
  cursor: pointer;
}
</style>
